import React from "react";
import "../component/partnerTable.css";

const PartnerTable = ({
  page,
  partners,
  onEditPartnerClicked,
  onDeletePartnerClicked,
}) => {
  const editPartner = (partner) => {
    onEditPartnerClicked(partner);
  };

  const deletePartner = (partner) => {
    onDeletePartnerClicked(partner);
  };

  return (
    <div className="partner-table-container">
      <table className="partner-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Supplier</th>
            <th>Alamat Partner</th>
            <th>Kota Partner</th>
            <th>No Telpon Partner</th>
            <th>Penanggung Jawab Partner</th>
            <th>Kontak Penanggung Jawab</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {partners.length > 0 ? (
            partners.map((partner, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{partner.partner_name}</td>
                <td>{partner.partner_address}</td>
                <td>{partner.partner_city}</td>
                <td>{partner.partner_phone_number}</td>
                <td>{partner.partner_contact_person_name}</td>
                <td>{partner.partner_contact_person_phone_number}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editPartner(partner);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deletePartner(partner);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PartnerTable;
